export default {
  apiKey: 'AIzaSyAZsa4EncfdO0DuYZEqLzCtirIPwz7kOeU',
  authDomain: 'ipfindable-io.firebaseapp.com',
  projectId: 'ipfindable-io',
  storageBucket: 'ipfindable-io.appspot.com',
  messagingSenderId: '694255129309',
  appId: '1:694255129309:web:833afe64510795cac90134',
  measurementId: 'G-EMQZW658DQ'
};
